import {ProviderModel} from './ProviderModel';

export class MinimumCommModel {
  id: number;
  anno: number;
  value: number;
  provider: ProviderModel;


  constructor(id?: number, anno?: number, value?: number, provider?: ProviderModel) {
    this.id = id;
    this.anno = anno;
    this.value = value;
    this.provider = provider;
  }
}
